export default __webpack_public_path__ + "static/media/git.c0308ce2.png";